import {TranslateLoader} from "@ngx-translate/core";
import {Observable, of} from "rxjs";

//import translation files directly to improve performance and avoid errors in chrome
import deTranslations from 'assets/i18n/de.json';

export class CustomTranslateLoaderService extends TranslateLoader{

  getTranslation(lang: string): Observable<object> {
    switch (lang) {
      case 'de':
      default:
        return of(deTranslations);
    }
  }
}
